import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function SEOBlog() {
  return (
    <ToolShell
      testid="tool-blog-page" eyebrow="Pro Tool" toolKey="blog" title="SEO Blog Writer"
      subtitle="A 1500-2500 word, ranked-ready blog post for dive businesses."
      endpoint="/tools/seo-blog" tier="pro" transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "target_keyword", label: "Target keyword", type: "text", required: true, placeholder: "e.g. open water course malta" },
        { key: "audience_intent", label: "Who's searching and why?", type: "textarea", rows: 3, placeholder: "e.g. UK tourists planning a Malta trip, comparing dive centres" },
        { key: "angle", label: "Your angle (optional)", type: "text" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock label="Target keyword">{o.target_keyword}</OutputBlock>
          <OutputBlock label="Meta title" copyValue={o.meta_title}>{o.meta_title}</OutputBlock>
          <OutputBlock label="Meta description" copyValue={o.meta_description}>{o.meta_description}</OutputBlock>
          <OutputBlock label="Slug">/{o.slug}</OutputBlock>
          <OutputBlock label="Secondary keywords"><div className="flex flex-wrap gap-2">{(o.secondary_keywords || []).map((k) => <span key={`kw-${k}`} className="dms-badge">{k}</span>)}</div></OutputBlock>
          <OutputBlock label="Outline"><ol className="list-decimal pl-5 space-y-1">{(o.outline || []).map((h, i) => <li key={`outline-${i}-${String(h).slice(0, 24)}`}>{h}</li>)}</ol></OutputBlock>
          {o.article && (
            <div className="dms-card p-6 space-y-4">
              <h2 className="font-heading font-bold text-2xl text-[#0A2342]">{o.article.h1}</h2>
              <p className="whitespace-pre-wrap leading-relaxed">{o.article.intro}</p>
              {(o.article.sections || []).map((s, i) => (
                <div key={`sec-${i}-${(s.h2 || "").slice(0, 24)}`}>
                  <h3 className="font-heading font-bold text-lg text-[#0A2342] mt-4">{s.h2}</h3>
                  <p className="mt-2 whitespace-pre-wrap leading-relaxed text-[14.5px]">{s.body}</p>
                  {(s.h3_subsections || []).map((h, j) => (
                    <div key={`sub-${j}-${(h.h3 || "").slice(0, 24)}`} className="mt-3 pl-4 border-l-2 border-[#E2E8F0]">
                      <h4 className="font-heading font-bold text-[15px] text-[#1D4E89]">{h.h3}</h4>
                      <p className="mt-1 whitespace-pre-wrap leading-relaxed text-[14px]">{h.body}</p>
                    </div>
                  ))}
                </div>
              ))}
              <div><h3 className="font-heading font-bold text-lg text-[#0A2342]">Conclusion</h3><p className="mt-2 whitespace-pre-wrap leading-relaxed">{o.article.conclusion}</p></div>
              {(o.article.faq || []).length > 0 && (
                <div className="mt-4">
                  <h3 className="font-heading font-bold text-lg text-[#0A2342]">FAQ</h3>
                  <div className="mt-3 space-y-3">{o.article.faq.map((f) => (<div key={`faq-${f.q}`}><div className="font-semibold">{f.q}</div><div className="mt-1 text-[#475569]">{f.a}</div></div>))}</div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    />
  );
}
